import {EditorContent} from '@tiptap/react';
import React, {ReactElement} from 'react';
import {IElementStaticTableV2} from '../../../incase-domain/elements/staticTableV2';
import {useGetEditor} from '../tipTap/getEditor';
import TextSelectionFloatingToolbar from '../tipTap/toolbar/TextSelectionFloatingToolbar';

interface ElementStaticTableComponentProps {
    element: IElementStaticTableV2;
}

function ElementStaticTableComponentV2(props: ElementStaticTableComponentProps): ReactElement {
    const {element} = props;

    const {editor, handleDoubleClick, handleBlur, handleClick} = useGetEditor({id: element.id, element});

    return (
        <div
            id={element.id}
            className={`c-tableElementV2 ${editor && editor.isFocused ? 'is-active' : ''}`}
            onDoubleClick={handleDoubleClick}
            onClick={handleClick}
        >
            <EditorContent style={{height: '100%'}} editor={editor} onBlur={handleBlur} />
            <TextSelectionFloatingToolbar editor={editor} />
        </div>
    );
}

export default ElementStaticTableComponentV2;
